var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"m-preview-frame"},[_c('c-layout-standard',[_c('transition',{attrs:{"name":"ct-page","mode":"out-in"}},[_c(_vm.page,{tag:"component"})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }